import { render, staticRenderFns } from "./Opnet.vue?vue&type=template&id=b42ec0dc&scoped=true&"
import script from "./Opnet.vue?vue&type=script&lang=js&"
export * from "./Opnet.vue?vue&type=script&lang=js&"
import style0 from "./Opnet.vue?vue&type=style&index=0&id=b42ec0dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42ec0dc",
  null
  
)

export default component.exports